/*
 * @Author: Teemo Ding
 * @Date: 2021-10-27 15:02:42
 * @LastEditTime: 2021-10-27 15:52:19
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/parcelLocker.ts
 */
import { get, post, remove } from 'src/tools/server';

// 获取页面country/region 和phone 的area 的接口
export const getParcelLockersList = (warehouseUuid) => {
  return get<any>(
    `/portal/setting/store/logistics/parcelLockers/${warehouseUuid}`,
    {},
  );
};

export const saveParcelLocker = (data) => {
  return post<any>(`/portal/setting/store/logistics/parcelLocker`, data, {});
};

export const getParcelLockerDetail = (uuid) => {
  return get<any>(`/portal/setting/store/logistics/parcelLocker/${uuid}`, {});
};

export const deleteParcelLocker = (uuid) => {
  return remove<any>(
    `/portal/setting/store/logistics/parcelLocker/${uuid}`,
    {},
  );
};
